import useClevertapForItinerary from '@/src/hooks/analytics/clevertap/itinerary'
import { TextField, TextFieldProps } from '@mui/material'
import { ChangeEvent, FC, memo, useEffect, useRef, useState } from 'react'

const ItineraryTextField: FC<
    TextFieldProps & {
        logerror?: 'true'
    }
> = ({ value, onChange, ...props }) => {
    const { triggerItineraryEvent } = useClevertapForItinerary()

    const [localValue, setLocalValue] = useState(value)
    const inputRef = useRef<HTMLInputElement>(null)
    const timeoutRef = useRef<NodeJS.Timeout>()

    const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const value = e.target?.value?.trimStart()
        setLocalValue(value)
        if (value) {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current)
            }
            timeoutRef.current = setTimeout(() => {
                onChange?.(e)
                timeoutRef.current = undefined
            }, 300)
        }
    }

    useEffect(() => {
        if (value !== inputRef?.current?.value && inputRef.current) {
            setLocalValue(value)
        }
    }, [value])

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current)
            }
        }
    }, [])

    useEffect(() => {
        if (props.error && props.logerror) {
            triggerItineraryEvent('Air_Failures', {
                action_name: `${props.id} ItineraryTextField-validation-error`,
                action_type: 'Validation',
                action_error: props.helperText || '',
                action_value: value
            })
        }
    }, [props.error, props.logerror, value, props.helperText, props.id])

    return (
        <TextField
            fullWidth
            size="small"
            variant="outlined"
            inputRef={inputRef}
            sx={{
                '& .MuiInputBase-input': { py: 0.5, px: 1.5, fontSize: 13, height: 26, borderRadius: 1 },
                borderRadius: 1
            }}
            value={localValue}
            onChange={handleChange}
            {...props}
        />
    )
}

export default memo(ItineraryTextField, (prev, next) => {
    return Boolean(prev.value === next.value) && Boolean(prev.error && next.error)
})
